import { useState } from "react";
import { deleteMultipleNotesURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useDeleteMultipleNotes = (token, onDeleteSuccess) => {
  const [loading, setLoading] = useState(false);

  const deleteMultipleNotes = async (idsSintesis) => {
    if (!idsSintesis || idsSintesis.length === 0) return false;
    setLoading(true);

    try {
      const response = await fetch(deleteMultipleNotesURL(), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ids_sintesis: idsSintesis }),
      });

      const data = await response.json();

      if (!response.ok) {
        toastAlert(data.message || "Error al eliminar las notas", "error");
        setLoading(false);
        return false;
      }

      toastAlert(data.message || "Notas eliminadas correctamente", "success");
      setLoading(false);
      onDeleteSuccess();
      return true;
    } catch (error) {
      toastAlert("Error al eliminar las notas: " + error, "error");
      setLoading(false);
      return false;
    }
  };

  return { loading, deleteMultipleNotes };
};

